import { useField } from 'formik';
import {
  ReportSubType,
  ReportType,
  useReportsFindByCompanyQuery,
} from 'generated/graphql';
import { useMemo } from 'react';
import {
  FormikSelectFormField,
  TSelectOption,
} from '@spotted-zebra-uk/ui-components';

export default function ReportSelect({
  companyId,
  companyDefaultReportId,
  subType,
  name,
  id,
  label,
  dataTestId,
}: {
  companyId: number;
  companyDefaultReportId?: number;
  subType: ReportSubType;
  name: string;
  id: string;
  label: string;
  dataTestId: string;
}) {
  const companyReportsQuery = useReportsFindByCompanyQuery({
    fetchPolicy: 'no-cache',
    variables: {
      type: ReportType.StageResults,
      subType,
      ownerId: companyId,
      includeSharedReports: true,
    },
  });

  const candidateReportOptions: TSelectOption<number>[] = useMemo(() => {
    return (
      companyReportsQuery.data?.ReportsFindByCompany?.map(report => ({
        label: report.name,
        value: report.id,
        labelDescription:
          report.id === companyDefaultReportId ? 'Default' : undefined,
      })) || []
    );
  }, [companyReportsQuery.data, companyDefaultReportId]);

  return (
    <FormikSelectFormField<number>
      id={id}
      name={name}
      label={label}
      options={candidateReportOptions}
      useFormikField={useField}
      data-testid={`${dataTestId}__${name}-select`}
      hasClearIndicator={false}
      placeholder={label}
    />
  );
}
